"use client";

import React from "react";
import classNames from "classnames";
import { LinkWithSVGProps } from "./types";
import "./linkWithSvg.scss";

const LinkWithSVG = ({
  fileUrl,
  label,
  customClassName,
  secondary,
  iconRight,
  svg,
  ...props
}: LinkWithSVGProps) => {
  const classnames = classNames(`link ${customClassName}`, {
    secondary: secondary,
    iconRight: iconRight,
  });

  return (
    <div className={classnames}>
      <a
        href={fileUrl}
        target="_blank"
        rel="noreferrer"
        {...props}>
        {svg && (
          <div
            className="svg"
            data-testid="svg-icon">
            {svg}
          </div>
        )}
        {label}
      </a>
    </div>
  );
};

export default LinkWithSVG;
